// import * as app from "./route/app";
import {getClient} from "../../config";

export async function joinWaitlist(emailAddress: string) {
  return await getClient().post({
    data: {emailAddress},
    path: "/web/waitlist",
  });
}

export async function getWaitlist(waitlistId: string) {
  return await getClient().get({
    path: `/web/waitlist/${waitlistId}`,
  });
}
